module.exports = __webpack_public_path__ + "img/core42-hcms.7b8be071.svg";